const languageAllow = ['markup', 'javascript', 'json', 'css',  'c#', 'yaml', 'python', 'java', 'cpp', 'go'];

/*
    v2接口拉新文档，代码片断格式
    <div class="iwiki-codeBlock-div" language="java" ...>
        ...
    </div>
*/
export const handleCodeV2 = (html) => {
  let result = html;
  const codeList = html.match(/<div class="iwiki-codeBlock-div"(.*?)div>/gms) || [];

  codeList.forEach((codeItem) => {
    let codeTemp = codeItem;
    let language = 'javascript';

    const languageTag = codeTemp.match(/<div class="iwiki-codeBlock-div".*? language="(.*?)".*?div>/gms);
    if (languageTag && languageTag.length > 0) {
      let languageFromTag = languageTag[0].replace(
        /<div class="iwiki-codeBlock-div".*? language="(.*?)".*?div>/gms,
        '$1',
      );
      languageFromTag = languageFromTag.replace(/js$/, 'javascript');
      languageFromTag = languageFromTag.replace(/xml$/, 'markup');
      languageFromTag = languageFromTag.replace(/py$/, 'python');
      if (languageAllow.includes(languageFromTag)) {
        language = languageFromTag;
      }
    }


    /*
      取出代码文本
    */
    let codeContent = '';
    const preTag = codeTemp.match(/<pre.*?>(.*?)<\/pre>/gms);
    if (preTag && preTag.length > 0) {
      codeContent = preTag[0].replace(
        /<pre.*?>(.*?)<\/pre>/gms,
        '$1',
      );
    }

    /*
      替换代码文本中如html标签的<br>换行标签为\n
    */
    codeContent = codeContent.replace(/<br>/gms, '\n');


    codeTemp = codeTemp.replace(
      /<div class="iwiki-codeBlock-div"(.*?)div>/gms,
      `<pre class="language-${language} line-numbers"><code>${codeContent}</code></pre>`,
    );

    result = result.replace(codeItem, codeTemp);
  });

  return result;
};


/*
    v2接口拉老文档，代码片断格式
    <div class="code panel pdl conf-macro output-block" style="border-width: 1px;" data-hasbody="true" data-macro-name="code">
        <div class="codeContent panelContent pdl">
            <pre class="syntaxhighlighter-pre" data-syntaxhighlighter-params="brush: java; gutter: false; theme: Confluence" data-theme="Confluence">
                ...
            </pre>
        </div>
    </div>
*/
export const handleCodeV2FromOldDoc = (html) => {
  let result = html;
  const codeList = html.match(/<div class="code panel.*?<\/div>.*?<\/div>/gms) || [];

  codeList.forEach((codeItem) => {
    const codeTemp = codeItem;
    let language = 'javascript';

    const languageTag = codeTemp.match(/<div class="code panel.*?<pre.*?brush:(.*?);.*?<\/div>.*?<\/div>/gms);
    if (languageTag && languageTag.length > 0) {
      let languageFromTag = languageTag[0].replace(
        /<div class="code panel.*?<pre.*?brush:(.*?);.*?<\/div>.*?<\/div>/gms,
        '$1',
      );
      languageFromTag = languageFromTag.replace(/js$/, 'javascript');
      languageFromTag = languageFromTag.replace(/xml$/, 'markup');
      languageFromTag = languageFromTag.replace(/py$/, 'python');
      if (languageAllow.includes(languageFromTag)) {
        language = languageFromTag;
      }
    }


    /*
      取出代码文本
    */
    let codeContent = '';
    const preTag = codeTemp.match(/<div class="code panel.*?<pre.*?>(.*?)<\/pre>.*?<\/div>.*?<\/div>/gms);
    if (preTag && preTag.length > 0) {
      codeContent = preTag[0].replace(
        /<div class="code panel.*?<pre.*?>(.*?)<\/pre>.*?<\/div>.*?<\/div>/gms,
        '$1',
      );
    }

    /*
      替换代码文本中如html标签的<br>换行标签为\n
    */
    codeContent = codeContent.replace(/<br>/gms, '\n');

    result = result.replace(codeItem, `<pre class="language-${language} line-numbers"><code>${codeContent}</code></pre>`);
  });

  return result;
};
